<template>
  <transition name="cookie-banner">
    <div v-if="showBanner" class="cookie-banner" role="dialog" aria-live="polite" aria-label="Уведомление о файлах cookie">
      <div class="cookie-banner__inner">
        <div class="cookie-banner__text">
          Данный сайт использует файлы cookies с целью безопасности, а также оптимизации и персонализации содержимого сайта и рекламы, возможности использования функций социальных сетей и анализа трафика. Если вы остаетесь на нашем сайте, это означает, что вы не возражаете против использования этих технологий. <a :href="policyUrl" target="_blank" rel="noopener noreferrer" class="cookie-banner__link">Политика конфиденциальности</a>
        </div>
        <button
          type="button"
          class="cookie-banner__button"
          @click="handleAccept"
        >
          Согласиться
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { hasCookieBannerBeenAccepted, setCookieConsent } from '@/utils/cookieConsent';

export default {
  name: 'CookieBanner',
  data() {
    return {
      showBanner: false,
      showTimer: null
    };
  },
  computed: {
    policyUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/policy`;
    }
  },
  mounted() {
    if (!hasCookieBannerBeenAccepted()) {
      this.showTimer = window.setTimeout(() => {
        this.showBanner = true;
      }, 1500);
    }
  },
  beforeUnmount() {
    if (this.showTimer) {
      window.clearTimeout(this.showTimer);
      this.showTimer = null;
    }
  },
  methods: {
    handleAccept() {
      if (this.showTimer) {
        window.clearTimeout(this.showTimer);
        this.showTimer = null;
      }
      setCookieConsent();
      this.showBanner = false;
    },
  }
};
</script>

<style lang="scss" scoped>
.cookie-banner-enter-active,
.cookie-banner-leave-active {
  transition: opacity 0.2s ease;
}

.cookie-banner-enter-from,
.cookie-banner-leave-to {
  opacity: 0;
}

.cookie-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  pointer-events: none;
}

.cookie-banner__inner {
  border-radius: 2.4rem 2.4rem 0 0;
  padding: 3rem 6rem;
  pointer-events: auto;
  max-width: 192rem;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 8.5rem;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background: #fff;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 2rem;
    padding: 2rem;
  }
}

.cookie-banner__text {
  font-weight: 300;
  font-size: 1.8rem;
  line-height: 1.1;
  color: var(--text-accent-1-100);
  width: calc(100% - 8.5rem - 20rem);

  @media (max-width: 767px) {
    width: 100%;
  }
}

.cookie-banner__link {
  display: inline;
  color: var(--brand-accent-1-100, #01146c);
  text-decoration: underline;
  text-underline-offset: 0.12em;

  &:hover {
    text-decoration: none;
  }
}

.cookie-banner__button {
  width: 20rem;
  min-width: 20rem;
  background: var(--fill-accent-1-1);
  border-radius: 1.8rem;
  padding: 0 3.2rem .4rem;
  height: 7.2rem;
  cursor: pointer;
  border: none;
  transition: opacity 0.2s ease, transform 0.15s ease;
  font-weight: 300;
  font-size: 2.2rem;
  line-height: 1.3;
  color: var(--text-inverse-100);

  &:hover {
    opacity: 0.92;
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 767px) {
    width: 100%;
  }
}
</style>
